import { create } from 'zustand';

type PlanGroupSubType = 'CORE' | 'MICRO_EMAIL' | 'SOCIAL' | 'EVENTS' | 'UNKNOWN';

interface ActiveSessionStore {
  accountId: number | null;
  userId: string | null;
  partnerId: number | null;
  planGroupSubType: PlanGroupSubType | null;
  isMobile: boolean | null;
  isModular: boolean | null;
  shouldShowWelcome: boolean;
  csrfToken: string | null;
}

const useActiveSessionStore = create<ActiveSessionStore>()(() => ({
  accountId: null,
  userId: null,
  partnerId: null,
  planGroupSubType: null,
  isMobile: null,
  isModular: null,
  shouldShowWelcome: false,
  csrfToken: null,
}));

const useSessionAccountId = () => useActiveSessionStore((state) => state.accountId);
const useSessionUserId = () => useActiveSessionStore((state) => state.userId);
const useSessionPartnerId = () => useActiveSessionStore((state) => state.partnerId);
const useSessionIsMobile = () => useActiveSessionStore((state) => state.isMobile);
const useSessionIsModular = () => useActiveSessionStore((state) => state.isModular);
const useSessionShouldShowWelcome = () => useActiveSessionStore((state) => state.shouldShowWelcome);
const useSessionCsrfToken = () => useActiveSessionStore((state) => state.csrfToken);
const useSessionPlanGroupSubType = () => useActiveSessionStore((state) => state.planGroupSubType);

export {
  useActiveSessionStore,
  useSessionAccountId,
  useSessionCsrfToken,
  useSessionIsMobile,
  useSessionIsModular,
  useSessionPartnerId,
  useSessionPlanGroupSubType,
  useSessionShouldShowWelcome,
  useSessionUserId,
};
export type { PlanGroupSubType };
